import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { InputModule } from './../../forms/input/input.module';
import { RtPhoneInputComponent } from './phone-input.component';

@NgModule({
  declarations: [RtPhoneInputComponent],
  exports: [RtPhoneInputComponent],
  imports: [CommonModule, I18nModule, InputModule],
})
export class RtPhoneInputModule {}

export { RtPhoneInputComponent } from './phone-input.component';
